
import PanelFooter from './PanelFooter.jsx';

export default PanelFooter;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/PanelSmallScreen/PanelFooter/index.js